import React from 'react';

const StatusPill = ({ 
  text, 
  color, 
  size = 'small', // 'small' or 'medium'
  customPadding = null // Allow custom padding override
}) => {
  // Default styling based on size
  const defaultPadding = size === 'small' ? '4px 10px' : '4px 12px';
  const padding = customPadding || defaultPadding;
  const fontSize = size === 'small' ? '12px' : '12px';

  return (
    <span
      style={{
        display: 'inline-block',
        padding: padding,
        borderRadius: '30px',
        fontSize: fontSize,
        fontWeight: 600,
        fontFamily: 'Montserrat, sans-serif',
        textTransform: 'none',
        letterSpacing: '0px',
        opacity: 1,
        backgroundColor: color,
        color: 'white',
        border: `1px solid ${color}`,
      }}
    >
      {text}
    </span>
  );
};

export default StatusPill;
